import * as accountUsers from './generated/account-users/account-users';
import * as account from './generated/account/account';
import * as activity from './generated/activity/activity';
import * as appPartner from './generated/app-partner/app-partner';
import * as authentication from './generated/authentication/authentication';
import * as backups from './generated/backups/backups';
import * as bandwidth from './generated/bandwidth/bandwidth';
import * as billing from './generated/billing/billing';
import * as cdnCache from './generated/cdn-cache/cdn-cache';
import * as customSsl from './generated/custom-ssl/custom-ssl';
import * as domains from './generated/domains/domains';
import * as files from './generated/files/files';
import * as ftpAccounts from './generated/ftp-accounts/ftp-accounts';
import * as partner from './generated/partner/partner';
import * as passwordProtection from './generated/password-protection/password-protection';
import * as passwordStrength from './generated/password-strength/password-strength';
import * as plugins from './generated/plugins/plugins';
import * as reporting from './generated/reporting/reporting';
import * as shopShield from './generated/shop-shield/shop-shield';
import * as siteTemplates from './generated/site-templates/site-templates';
import * as siteTransfers from './generated/site-transfers/site-transfers';
import * as siteUsers from './generated/site-users/site-users';
import * as sites from './generated/sites/sites';
import * as sshKeys from './generated/ssh-keys/ssh-keys';
import * as themes from './generated/themes/themes';
import * as visitors from './generated/visitors/visitors';
import * as wordPress from './generated/word-press/word-press';

export const RocketAPI = {
  account,
  accountUsers,
  activity,
  appPartner,
  authentication,
  backups,
  bandwidth,
  billing,
  cdnCache,
  customSsl,
  domains,
  files,
  ftpAccounts,
  partner,
  passwordProtection,
  passwordStrength,
  plugins,
  reporting,
  shopShield,
  siteTemplates,
  siteTransfers,
  siteUsers,
  sites,
  sshKeys,
  themes,
  visitors,
  wordPress,
} as const;
